import styled from "@emotion/styled";

import { ReactComponent as IconEdit } from "../../assets/icons/edit.svg";
import React from "react";
import { IconProps } from "../../App";

const StyledEditIcon = styled(IconEdit)`
  width: 24px;
  height: 24px;
  line-height: 24px;
`;

const IconUsers: React.FC<IconProps> = ({ color }) => {
  return (
    <svg viewBox="0 0 24 24" className="iconUsers">
      <defs>
        <linearGradient x1="47.1406142%" y1="20.1284775%" x2="100%" y2="100%" id="linearGradient-1">
          <stop stopOpacity="0" offset="0%"></stop>
          <stop stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
      </defs>
      <g
        id="users-(1)"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        transform="translate(-28.000000, -504.000000) translate(29.000000, 504.000000)"
      >
        <path
          className="toggle"
          d="M15,19 C15,16 12.1875,13 7.5,13 C2.8125,13 0,16 0,19"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          className="toggle"
          d="M24,14.8333333 C23.4820056,14.2777778 22.6991253,14 21.6513589,14 C18.5020013,14 17,16.5 17,19"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          transform="translate(20.500000, 16.500000) scale(-1, 1) translate(-20.500000, -16.500000) "
        />
        <circle
          fill="url(#a)"
          cx="7.5"
          cy="5.5"
          r="5.5"
          style={{ display: "none" }}
          className="show"
        ></circle>
        <circle
          stroke={color}
          cx="7.5"
          cy="5.5"
          r="4.5"
          strokeWidth="2"
          className="toggle"
        ></circle>
        <circle
          fill="url(#a)"
          cx="19"
          cy="8"
          r="3.5"
          style={{ display: "none" }}
          className="show"
        ></circle>
        <circle stroke={color} cx="19" cy="8" r="3.5" strokeWidth="2" className="toggle"></circle>
      </g>
    </svg>
  );
};

const IconCompany: React.FC<IconProps> = () => {
  return (
    <svg
      id="IconCompany"
      enable-background="new 0 0 512 512"
      height="512"
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <g>
          <g>
            <path
              d="m487 444.811h-6.347v-123.851c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v123.852h-159.104v-203.88h152.975c3.38 0
  6.13 2.75 6.13 6.129v38.565c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358
  7.5-7.5v-38.565c0-11.651-9.479-21.129-21.13-21.129h-152.975v-136.294c0-10.913-8.491-20.13-19.352-21.049v-15.045c0-10.956-8.556-20.209-19.479-21.065l-194.24-15.224c-12.265-.969-22.78 8.758-22.78
  21.065v12.011c-11.123.95-19.351 10.254-19.351 21.05v373.429h-6.347c-13.785 0-25 11.215-25 25s11.215 25 25 25h462c13.785 0
  25-11.215 25-25s-11.215-24.999-25-24.999zm-421.302-406.49c0-3.592 3.057-6.392 6.609-6.111l194.24 15.223c3.168.249 5.65
  2.933 5.65 6.111v13.863l-206.5-16.184v-12.902zm-19.351 33.061c0-3.621 3.097-6.399 6.608-6.111l232.942 18.256c3.169.249
  5.651 2.933 5.651 6.111v355.173h-20.957v-107.38c0-6.826-5.553-12.379-12.379-12.379h-69.68c-6.826 0-12.379 5.553-12.379
  12.379v48.653c0 4.142 3.358 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-46.032h64.438v104.759h-64.438v-23.664c0-4.142-3.358-7.5-7.5-7.5s-7.5
  3.358-7.5 7.5v23.664h-129.806zm440.653 408.429h-462c-5.514 0-10-4.486-10-10s4.486-10 10-10h462c5.514 0 10 4.486 10 10s-4.486 10-10 10z"
            />
            <path
              d="m75.905 162.943h30.358c7.137 0 12.943-5.806 12.943-12.942v-23.357c0-7.136-5.806-12.942-12.943-12.942h-30.358c-7.136 0-12.942
  5.806-12.942 12.942v23.357c0 7.136 5.806 12.942 12.942 12.942zm2.058-34.242h26.244v19.242h-26.244z"
            />
            <path
              d="m151.599 162.943h30.358c7.136 0 12.942-5.806 12.942-12.942v-23.357c0-7.136-5.806-12.942-12.942-12.942h-30.358c-7.136
  0-12.942 5.806-12.942 12.942v23.357c-.001 7.136 5.805 12.942 12.942 12.942zm2.057-34.242h26.243v19.242h-26.243z"
            />
            <path
              d="m227.292 162.943h30.358c7.137 0 12.942-5.806 12.942-12.942v-23.357c0-7.136-5.806-12.942-12.942-12.942h-30.358c-7.136
  0-12.942 5.806-12.942 12.942v23.357c-.001 7.136 5.805 12.942 12.942 12.942zm2.057-34.242h26.243v19.242h-26.243z"
            />
            <path
              d="m75.905 230.38h30.358c7.137 0 12.943-5.806 12.943-12.942v-23.358c0-7.136-5.806-12.942-12.943-12.942h-30.358c-7.136
  0-12.942 5.806-12.942 12.942v23.357c0 7.137 5.806 12.943 12.942 12.943zm2.058-34.242h26.244v19.242h-26.244z"
            />
            <path
              d="m151.599 230.38h30.358c7.136 0 12.942-5.806 12.942-12.942v-23.358c0-7.136-5.806-12.942-12.942-12.942h-30.358c-7.136
  0-12.942 5.806-12.942 12.942v23.357c-.001 7.137 5.805 12.943 12.942 12.943zm2.057-34.242h26.243v19.242h-26.243z"
            />
            <path
              d="m227.292 230.38h30.358c7.137 0 12.942-5.806 12.942-12.942v-23.358c0-7.136-5.806-12.942-12.942-12.942h-30.358c-7.136
  0-12.942 5.806-12.942 12.942v23.357c-.001 7.137 5.805 12.943 12.942 12.943zm2.057-34.242h26.243v19.242h-26.243z"
            />
            <path
              d="m75.905 297.816h30.358c7.137 0 12.943-5.806 12.943-12.942v-23.357c0-7.136-5.806-12.942-12.943-12.942h-30.358c-7.136
  0-12.942 5.806-12.942 12.942v23.357c0 7.136 5.806 12.942 12.942 12.942zm2.058-34.242h26.244v19.242h-26.244z"
            />
            <path
              d="m144.551 325.052h-67.188c-7.94 0-14.4 6.46-14.4 14.4v20.442c0 7.94 6.46 14.4 14.4 14.4h67.188c7.94 0 14.4-6.46
  14.4-14.4v-20.442c0-7.94-6.46-14.4-14.4-14.4zm-.6 34.242h-65.988v-19.242h65.988z"
            />
            <path
              d="m151.599 297.816h30.358c7.136 0 12.942-5.806 12.942-12.942v-23.357c0-7.136-5.806-12.942-12.942-12.942h-30.358c-7.136
  0-12.942 5.806-12.942 12.942v23.357c-.001 7.136 5.805 12.942 12.942 12.942zm2.057-34.242h26.243v19.242h-26.243z"
            />
            <path
              d="m227.292 297.816h30.358c7.137 0 12.942-5.806 12.942-12.942v-23.357c0-7.136-5.806-12.942-12.942-12.942h-30.358c-7.136
  0-12.942 5.806-12.942 12.942v23.357c-.001 7.136 5.805 12.942 12.942 12.942zm2.057-34.242h26.243v19.242h-26.243z"
            />
            <path
              d="m380.573 291.297c0-7.607-6.189-13.797-13.797-13.797h-30.628c-7.607 0-13.797 6.189-13.797 13.797v24.293c0 7.607
  6.189 13.797 13.797 13.797h30.628c7.607 0 13.797-6.189 13.797-13.797zm-15 23.09h-28.222v-21.887h28.222z"
            />
            <path
              d="m366.776 346.717h-30.628c-7.607 0-13.797 6.189-13.797 13.797v24.293c0 7.607 6.189 13.797 13.797 13.797h30.628c7.607
  0 13.797-6.189 13.797-13.797v-24.293c0-7.608-6.189-13.797-13.797-13.797zm-1.203 36.887h-28.222v-21.887h28.222z"
            />
            <path
              d="m450.333 291.297c0-7.607-6.189-13.797-13.797-13.797h-30.627c-7.607 0-13.797 6.189-13.797 13.797v24.293c0 7.607 6.189
  13.797 13.797 13.797h30.627c7.607 0 13.797-6.189 13.797-13.797zm-15 23.09h-28.221v-21.887h28.221z"
            />
            <path
              d="m436.536 346.717h-30.627c-7.607 0-13.797 6.189-13.797 13.797v24.293c0 7.607 6.189 13.797 13.797 13.797h30.627c7.607
  0 13.797-6.189 13.797-13.797v-24.293c0-7.608-6.189-13.797-13.797-13.797zm-1.203 36.887h-28.221v-21.887h28.221z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

const IconLog: React.FC<IconProps> = () => {
  return (
    <svg
      id="IconLogs"
      enable-background="new 0 0 512 512"
      viewBox="0 0 512 512"
      width="512"
      height="512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="M349.657,18.343A8,8,0,0,0,344,16H120A56.063,56.063,0,0,0,64,72V440a56.063,56.063,0,0,0,56,56H392a56.063,56.063,0,0,0,56-56V120a8,8,0,0,0-2.343-5.657ZM352,43.313,420.687,112H392a40.045,40.045,0,0,1-40-40ZM120,32H336V72a56.063,56.063,0,0,0,56,56h40V352H80V72A40.045,40.045,0,0,1,120,32ZM392,480H120a40.045,40.045,0,0,1-40-40V368H432v72A40.045,40.045,0,0,1,392,480Z" />
        <path d="M192,448H168V392a8,8,0,0,0-16,0v64a8,8,0,0,0,8,8h32a8,8,0,0,0,0-16Z" />
        <path d="M248,384c-17.645,0-32,17.944-32,40s14.355,40,32,40,32-17.944,32-40S265.645,384,248,384Zm0,64c-8.673,0-16-10.99-16-24s7.327-24,16-24,16,10.99,16,24S256.673,448,248,448Z" />
        <path d="M352,416H336a8,8,0,0,0,0,16h7.049c-2.252,9.217-8.236,16-15.049,16-8.673,0-16-10.99-16-24s7.327-24,16-24a10.675,10.675,0,0,1,4.588,1.058,8,8,0,0,0,6.824-14.473A26.587,26.587,0,0,0,328,384c-17.645,0-32,17.944-32,40s14.355,40,32,40,32-17.944,32-40A8,8,0,0,0,352,416Z" />
        <path d="M247.247,235.177l46.131,54.2a32.122,32.122,0,0,0,4.073,4.994,32,32,0,1,0,45.256-45.256,32.226,32.226,0,0,0-4.994-4.073l-54.2-46.131a63.8,63.8,0,0,0-14.35-68.589h0a64.381,64.381,0,0,0-75.7-11.043,8,8,0,0,0-1.85,12.694L212.6,152.945a8,8,0,0,1-11.313,11.313l-20.978-20.979a8,8,0,0,0-12.694,1.85,64.009,64.009,0,0,0,79.633,90.048Zm-69.685-72.016,12.41,12.411a24,24,0,0,0,33.941-33.941L211.5,129.221a48.364,48.364,0,0,1,46.352,12.409,47.859,47.859,0,0,1,8.785,55.826,8,8,0,0,0,1.933,9.74l59.165,50.362a8.049,8.049,0,0,0,.9.662,16,16,0,1,1-22.074,22.074,8.057,8.057,0,0,0-.663-.9l-50.361-59.165a8,8,0,0,0-9.74-1.933,47.857,47.857,0,0,1-55.825-8.785A48.353,48.353,0,0,1,177.562,163.161Z" />
      </g>
    </svg>
  );
};

const IconSessions: React.FC<IconProps> = () => {
  return (
    <svg
      id="IconSessions"
      enable-background="new 0 0 512 512"
      height="512"
      viewBox="0 0 50 60"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Page-1" fill="none" fill-rule="evenodd">
        <g id="053---Gym-Time" fill="rgb(0,0,0)" fill-rule="nonzero">
          <path
            id="Shape"
            d="m47 41h-2.069c-.507003-3.995865-3.9031042-6.9933065-7.931-7h-1c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h1c2.9246159.0054296 5.4201335 2.1166966 5.91 5h-1.91c-1.6568542 0-3 1.3431458-3 3v1c.0052514 1.2667854.8056491 2.3937454 2 2.816v8.184c0 2.209139 1.790861 4 4 4s4-1.790861 4-4v-8.184c1.1943509-.4222546 1.9947486-1.5492146 2-2.816v-1c0-1.6568542-1.3431458-3-3-3zm-1 15c0 1.1045695-.8954305 2-2 2s-2-.8954305-2-2v-8h4zm2-11c0 .5522847-.4477153 1-1 1h-6c-.5522847 0-1-.4477153-1-1v-1c0-.5522847.4477153-1 1-1h6c.5522847 0 1 .4477153 1 1z"
          />
          <path
            id="Shape"
            d="m43 18.266c.1228896-8.36433394-5.5327962-15.71093191-13.6503465-17.73146705-8.1175502-2.02053514-16.5572208 1.81759508-20.3696653 9.26356388-3.81244445 7.44596877-1.99272221 16.53705757 4.3920118 21.94190317.271081.2418092.6519724.3175978.9949697.197976.3429974-.1196218.5941504-.4158385.6560652-.7737815.0619149-.3579429-.075147-.7213107-.3580349-.9491945-4.8760908-4.1242089-6.83263515-10.753087-4.97750258-16.864048 1.85513258-6.11096098 7.16659348-10.53345723 13.51250258-11.250952 4.5694086-.51785703 9.14072.95542192 12.5478144 4.0440104s5.3205253 7.4938377 5.2521856 12.0919896c-.125 8.545-7.663 15.764-16.462 15.764h-11.538c-4.02789577.0066935-7.423997 3.004135-7.931 7h-2.069c-1.65685425 0-3 1.3431458-3 3v1c.00525139 1.2667854.80564914 2.3937454 2 2.816v8.184c0 2.209139 1.790861 4 4 4s4-1.790861 4-4v-8.184c1.1943509-.4222546 1.9947486-1.5492146 2-2.816v-1c0-1.6568542-1.3431458-3-3-3h-1.91c.48986653-2.8833034 2.9853841-4.9945704 5.91-5h11.538c9.868 0 18.321-8.121 18.462-17.734zm-35 37.734c0 1.1045695-.8954305 2-2 2s-2-.8954305-2-2v-8h4zm2-12v1c0 .5522847-.44771525 1-1 1h-6c-.55228475 0-1-.4477153-1-1v-1c0-.5522847.44771525-1 1-1h6c.55228475 0 1 .4477153 1 1z"
          />
          <path
            id="Shape"
            d="m25 31c7.1797017 0 13-5.8202983 13-13s-5.8202983-13-13-13-13 5.8202983-13 13c.0225079 7.170358 5.829642 12.9774921 13 13zm-8.976-6.663.816-.471c.3119508-.1773616.5049532-.5082732.5057421-.8671183s-.1907567-.6906021-.5019247-.8693336c-.3111679-.1787314-.694247-.1770325-1.0038174.0044519l-.816.471c-.5292779-1.1367544-.85844-2.356312-.973-3.605h.949c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-.949c.11456-1.248688.4437221-2.4682456.973-3.605l.816.471c.3095704.1814844.6926495.1831833 1.0038174.0044519.311168-.1787315.5027136-.5104885.5019247-.8693336s-.1937913-.6897567-.5057421-.8671183l-.816-.471c.7244186-1.0223053 1.6166947-1.91458137 2.639-2.639l.471.816c.1773616.3119508.5082732.5049532.8671183.5057421s.6906021-.1907567.8693336-.50192468c.1787314-.31116795.1770325-.694247-.0044519-1.00381742l-.466-.816c1.135197-.52872493 2.3530163-.8578744 3.6-.973v.949c0 .55228475.4477153 1 1 1s1-.44771525 1-1v-.949c1.2469837.1151256 2.464803.44427507 3.6.973l-.471.816c-.1814844.30957042-.1831833.69264947-.0044519 1.00381742.1787315.31116798.5104885.50271358.8693336.50192468s.6897567-.1937913.8671183-.5057421l.471-.816c1.0223053.72441863 1.9145814 1.6166947 2.639 2.639l-.816.471c-.3119508.1773616-.5049532.5082732-.5057421.8671183s.1907567.6906021.5019247.8693336c.3111679.1787314.694247.1770325 1.0038174-.0044519l.816-.471c.531004 1.1364405.8618611 2.3560108.978 3.605h-.949c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h.949c-.11456 1.248688-.4437221 2.4682456-.973 3.605l-.816-.471c-.47786-.2716903-1.0854205-.1067416-1.3602745.3693057-.2748541.4760473-.1139391 1.0846885.3602745 1.3626943l.816.471c-.7244186 1.0223053-1.6166947 1.9145814-2.639 2.639l-.471-.816c-.1773616-.3119508-.5082732-.5049532-.8671183-.5057421s-.6906021.1907567-.8693336.5019247c-.1787314.3111679-.1770325.694247.0044519 1.0038174l.471.816c-1.135197.5287249-2.3530163.8578744-3.6.973v-.949c0-.5522847-.4477153-1-1-1s-1 .4477153-1 1v.949c-1.248688-.11456-2.4682456-.4437221-3.605-.973l.471-.816c.2716903-.47786.1067416-1.0854205-.3693057-1.3602745-.4760473-.2748541-1.0846885-.1139391-1.3626943.3602745l-.471.816c-1.0240911-.7239808-1.918082-1.6162811-2.644-2.639z"
          />
          <path
            id="Shape"
            d="m28.293 22.707c.3923789.3789722 1.0160848.3735524 1.4018186-.0121814s.3911536-1.0094397.0121814-1.4018186l-3.707-3.707v-5.586c0-.5522847-.4477153-1-1-1s-1 .4477153-1 1v6c.0000566.2651948.1054506.5195073.293.707z"
          />
        </g>
      </g>
    </svg>
  );
};

const IconConfiguration: React.FC<IconProps> = () => {
  return (
    <svg
      id="IconConfiguration"
      height="512"
      viewBox="0 0 480 480"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <g>
          <path
            d="M296,280h-8.8c-3.31,0.006-6.271-2.059-7.408-5.168c-0.976-2.56-2.024-5.064-3.152-7.544
  c-1.402-3.016-0.762-6.587,1.6-8.928l6.272-6.28c9.311-9.393,9.294-24.541-0.04-33.912l-22.608-22.608
  c-9.383-9.328-24.537-9.328-33.92,0l-6.272,6.264c-2.346,2.353-5.911,2.992-8.928,1.6c-2.48-1.128-4.984-2.176-7.552-3.2
  c-3.125-1.129-5.204-4.101-5.192-7.424V184c0-13.255-10.745-24-24-24h-32c-13.255,0-24,10.745-24,24v8.8
  c0.006,3.31-2.059,6.271-5.168,7.408c-2.56,0.976-5.064,2.024-7.544,3.152c-3.017,1.395-6.583,0.756-8.928-1.6l-6.28-6.272
  c-9.382-9.322-24.53-9.322-33.912,0l-22.608,22.68c-9.328,9.383-9.328,24.537,0,33.92l6.264,6.272
  c2.362,2.341,3.002,5.912,1.6,8.928c-1.128,2.48-2.176,4.984-3.16,7.552c-1.145,3.127-4.134,5.194-7.464,5.16H24
  c-13.255,0-24,10.745-24,24v32c0,13.255,10.745,24,24,24h8.8c3.31-0.006,6.271,2.059,7.408,5.168
  c0.976,2.56,2.024,5.064,3.152,7.544c1.402,3.016,0.762,6.587-1.6,8.928l-6.272,6.28c-9.322,9.382-9.322,24.53,0,33.912
  l22.608,22.608c9.383,9.328,24.537,9.328,33.92,0l6.272-6.264c2.346-2.353,5.911-2.992,8.928-1.6
  c2.48,1.128,4.984,2.176,7.552,3.2c3.141,1.116,5.238,4.091,5.232,7.424v8.8c0,13.255,10.745,24,24,24h32
  c13.255,0,24-10.745,24-24v-8.8c-0.006-3.31,2.059-6.271,5.168-7.408c2.56-0.976,5.064-2.024,7.544-3.152
  c3.017-1.395,6.583-0.756,8.928,1.6l6.28,6.272c9.395,9.307,24.539,9.289,33.912-0.04l22.608-22.608
  c9.328-9.383,9.328-24.537,0-33.92l-6.264-6.272c-2.362-2.341-3.002-5.912-1.6-8.928c1.128-2.48,2.176-4.984,3.2-7.552
  c1.129-3.125,4.101-5.204,7.424-5.192h8.8c13.255,0,24-10.745,24-24v-32C320,290.745,309.255,280,296,280z M304,336
  c0,4.418-3.582,8-8,8h-8.8c-9.945,0.037-18.845,6.184-22.4,15.472c-0.848,2.24-1.765,4.445-2.752,6.616
  c-4.113,9.08-2.205,19.756,4.8,26.848l6.256,6.264c3.126,3.122,3.129,8.188,0.006,11.314c-0.002,0.002-0.004,0.004-0.006,0.006
  l-22.608,22.608c-3.124,3.123-8.188,3.123-11.312,0l-6.272-6.264c-7.089-7.011-17.769-8.92-26.848-4.8
  c-2.168,0.984-4.376,1.904-6.6,2.752C190.183,428.37,184.04,437.262,184,447.2v8.8c0,4.418-3.582,8-8,8h-32c-4.418,0-8-3.582-8-8
  v-8.8c-0.037-9.945-6.184-18.845-15.472-22.4c-2.24-0.848-4.445-1.765-6.616-2.752c-9.08-4.111-19.755-2.202-26.848,4.8
  l-6.264,6.256c-3.122,3.126-8.188,3.129-11.314,0.006c-0.002-0.002-0.004-0.004-0.006-0.006L46.872,410.52
  c-3.123-3.124-3.123-8.188,0-11.312l6.264-6.272c7.005-7.092,8.913-17.768,4.8-26.848c-0.984-2.168-1.904-4.376-2.752-6.6
  C51.638,350.197,42.744,344.044,32.8,344H24c-4.418,0-8-3.582-8-8v-32c0-4.418,3.582-8,8-8h8.8
  c9.945-0.037,18.845-6.184,22.4-15.472c0.848-2.24,1.765-4.445,2.752-6.616c4.113-9.08,2.204-19.756-4.8-26.848l-6.288-6.264
  c-3.126-3.122-3.129-8.188-0.006-11.314c0.002-0.002,0.004-0.004,0.006-0.006l22.608-22.608c3.124-3.123,8.188-3.123,11.312,0
  l6.272,6.264c7.089,7.011,17.769,8.92,26.848,4.8c2.168-0.984,4.376-1.904,6.6-2.752c9.294-3.543,15.451-12.438,15.496-22.384V184
  c0-4.418,3.582-8,8-8h32c4.418,0,8,3.582,8,8v8.8c0.037,9.945,6.184,18.845,15.472,22.4c2.24,0.848,4.445,1.765,6.616,2.752
  c9.079,4.12,19.759,2.211,26.848-4.8l6.264-6.256c3.136-3.102,8.184-3.102,11.32,0l22.608,22.608
  c3.123,3.124,3.123,8.188,0,11.312l-6.264,6.272c-7.004,7.092-8.913,17.768-4.8,26.848c0.984,2.168,1.904,4.376,2.752,6.6
  c3.554,9.281,12.446,15.424,22.384,15.464h8.8c4.418,0,8,3.582,8,8V336z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M231.84,316.8c-0.08-1.92-0.216-3.832-0.448-5.736c-0.256-2.048-0.56-4.08-0.984-6.072c-0.28-1.304-0.648-2.592-1-3.888
  c-0.448-1.648-0.952-3.272-1.512-4.872c-0.392-1.112-0.8-2.216-1.216-3.312c-1.03-2.562-2.208-5.063-3.528-7.488
  c-0.104-0.184-0.168-0.384-0.272-0.568c-2.081-3.704-4.491-7.215-7.2-10.488c-0.232-0.288-0.496-0.56-0.736-0.84
  c-1.104-1.304-2.24-2.568-3.432-3.776c-0.624-0.648-1.28-1.256-1.936-1.88c-0.8-0.744-1.6-1.48-2.4-2.184
  c-0.971-0.843-1.96-1.659-2.968-2.448l-1.312-0.976C190.517,253,175.466,247.992,160,248c-0.8,0-1.6,0.12-2.4,0.152
  c-1.704,0.048-3.416,0.144-5.136,0.32c-0.904,0.096-1.816,0.2-2.72,0.328c-2.608,0.343-5.196,0.827-7.752,1.448
  c-38.521,9.954-61.679,49.252-51.725,87.773c6.56,25.384,26.392,45.2,51.781,51.739c0.128,0,0.264,0.04,0.4,0.072
  c2.763,0.689,5.562,1.224,8.384,1.6c1.864,0.232,3.728,0.28,5.6,0.368c1.248,0.064,2.4,0.248,3.704,0.248
  c2.28,0,4.648-0.152,7.064-0.392c0.256,0,0.512-0.072,0.8-0.104c1.944-0.216,3.912-0.504,5.92-0.904
  c0.8-0.152,1.544-0.352,2.312-0.528c1.408-0.328,2.808-0.672,4.248-1.096c1.12-0.336,2.208-0.728,3.304-1.112
  c1.096-0.384,2.232-0.8,3.368-1.232c1.136-0.432,2.088-0.928,3.12-1.408c1.344-0.616,2.68-1.224,4-1.944h0.048
  c7.466-3.997,14.362-8.977,20.504-14.808c1.659-1.548,3.102-3.314,4.288-5.248c6.244-10.01,10.346-21.205,12.048-32.88
  c0.224-1.544,0.424-3.088,0.544-4.664c0.112-1.448,0.192-2.888,0.224-4.328c0-0.456,0.064-0.888,0.064-1.344
  C232,318.928,231.888,317.888,231.84,316.8z M215.896,322.04c0,0.664-0.056,1.328-0.096,1.984
  c-0.144,1.936-0.392,3.872-0.72,5.816c-2.99,16.633-13.317,31.033-28.112,39.2c-0.992,0.52-1.968,1.008-2.944,1.456l-0.664,0.32
  c-4.648,2.11-9.554,3.595-14.592,4.416c-0.352,0.056-0.712,0.12-1.072,0.168c-1,0.144-1.984,0.264-2.96,0.352
  c-1.288,0.112-2.584,0.176-3.904,0.2c-0.56,0-1.112,0-1.672,0c-1.893-0.022-3.783-0.139-5.664-0.352l-0.96-0.112
  c-2.2-0.288-4.382-0.699-6.536-1.232c-29.962-7.669-48.034-38.175-40.366-68.137c5.067-19.798,20.517-35.264,40.31-40.351l0-0.008
  c4.596-1.159,9.316-1.751,14.056-1.76c2.287,0.013,4.572,0.168,6.84,0.464c0.608,0.072,1.208,0.184,1.808,0.272
  c1.728,0.272,3.44,0.616,5.128,1.048c0.552,0.144,1.104,0.272,1.648,0.424c4.254,1.228,8.349,2.952,12.2,5.136
  c0.616,0.36,1.216,0.736,1.824,1.112c1.264,0.8,2.488,1.6,3.696,2.512c0.648,0.472,1.304,0.936,1.928,1.44
  c1.57,1.254,3.073,2.589,4.504,4c0.568,0.576,1.088,1.208,1.64,1.808c0.92,1,1.816,2.024,2.672,3.104
  c0.592,0.744,1.16,1.512,1.72,2.288c0.8,1.152,1.6,2.352,2.32,3.568c0.4,0.664,0.8,1.312,1.208,1.992
  c1.032,1.899,1.951,3.857,2.752,5.864c0.32,0.8,0.592,1.6,0.88,2.4c0.52,1.472,0.968,2.96,1.36,4.464
  c0.2,0.8,0.424,1.512,0.592,2.288c0.467,2.162,0.806,4.35,1.016,6.552c0.048,0.584,0.048,1.176,0.088,1.76
  C215.936,318.336,215.968,320.184,215.896,322.04z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M456,168h-25.16c-3.355,0.034-6.356-2.079-7.456-5.248c-2.481-7.431-5.483-14.679-8.984-21.688
  c-1.486-3.027-0.867-6.666,1.536-9.032l17.84-17.864c9.364-9.371,9.364-24.557,0-33.928L399.76,46.28
  c-9.371-9.364-24.557-9.364-33.928,0L348,64.104c-2.363,2.402-5.997,3.024-9.024,1.544c-7.01-3.519-14.26-6.537-21.696-9.032
  c-3.182-1.089-5.31-4.093-5.28-7.456V24c0-13.255-10.745-24-24-24h-48c-13.255,0-24,10.745-24,24v25.16
  c0.034,3.355-2.078,6.356-5.248,7.456c-7.432,2.494-14.68,5.51-21.688,9.024c-3.027,1.491-6.668,0.872-9.032-1.536l-17.864-17.84
  c-9.382-9.337-24.546-9.337-33.928,0L94.288,80.216c-9.369,9.372-9.369,24.564,0,33.936l26.232,26.28
  c3.173,3.074,8.238,2.994,11.312-0.18c2.999-3.096,3.006-8.012,0.016-11.116L105.6,102.864c-3.123-3.124-3.123-8.188,0-11.312
  L139.552,57.6c3.124-3.123,8.188-3.123,11.312,0l17.872,17.84c7.231,7.274,18.311,9.092,27.488,4.512
  c6.337-3.173,12.889-5.897,19.608-8.152c9.698-3.283,16.21-12.401,16.168-22.64V24c0-4.418,3.582-8,8-8h48c4.418,0,8,3.582,8,8
  v25.16c-0.041,10.237,6.471,19.352,16.168,22.632c6.722,2.256,13.277,4.982,19.616,8.16c9.179,4.556,20.244,2.736,27.48-4.52
  L377.136,57.6c3.124-3.123,8.188-3.123,11.312,0L422.4,91.56c3.118,3.123,3.118,8.181,0,11.304l-17.84,17.872
  c-7.267,7.235-9.084,18.31-4.512,27.488c3.173,6.337,5.897,12.889,8.152,19.608c3.281,9.7,12.4,16.212,22.64,16.168H456
  c4.418,0,8,3.582,8,8v48c0,4.418-3.582,8-8,8h-25.16c-10.237-0.041-19.352,6.471-22.632,16.168
  c-2.255,6.722-4.982,13.277-8.16,19.616c-4.564,9.178-2.743,20.247,4.52,27.48l17.84,17.872c3.123,3.124,3.123,8.188,0,11.312
  L388.44,374.4c-3.123,3.118-8.181,3.118-11.304,0l-26.288-26.232c-3.074-3.174-8.139-3.254-11.312-0.18
  c-3.174,3.074-3.254,8.139-0.18,11.312c0.064,0.066,0.13,0.132,0.196,0.196l26.28,26.232c9.371,9.364,24.557,9.364,33.928,0
  l33.952-33.944c9.369-9.372,9.369-24.564,0-33.936L415.896,300c-2.4-2.364-3.021-5.997-1.544-9.024
  c3.519-7.01,6.537-14.26,9.032-21.696c1.089-3.182,4.093-5.31,7.456-5.28H456c13.255,0,24-10.745,24-24v-48
  C480,178.745,469.255,168,456,168z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M337.536,142.464c-40.638-40.553-106.434-40.553-147.072,0c-3.069,3.178-2.981,8.243,0.197,11.312
  c3.1,2.994,8.015,2.994,11.115,0c34.135-34.596,89.852-34.969,124.448-0.834c34.596,34.135,34.969,89.852,0.834,124.448
  c-0.276,0.28-0.554,0.558-0.834,0.834c-3.178,3.07-3.266,8.134-0.196,11.312c3.07,3.178,8.134,3.266,11.312,0.196
  c0.066-0.064,0.132-0.13,0.196-0.196C378.089,248.898,378.089,183.102,337.536,142.464z"
          />
        </g>
      </g>
    </svg>
  );
};

const IconTenant: React.FC<IconProps> = () => {
  return (
    <svg
      id="IconTenant"
      xmlns="http://www.w3.org/2000/svg"
      height="512"
      viewBox="0 0 480 480"
      width="512"
    >
      <g>
        <g>
          <rect x="168" y="160" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="168" y="192" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="168" y="224" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="168" y="256" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="200" y="160" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="200" y="192" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="200" y="224" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="200" y="256" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="232" y="160" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="232" y="192" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="232" y="224" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="232" y="256" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="264" y="160" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="200" y="128" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="232" y="128" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="264" y="128" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="264" y="192" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="264" y="224" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="264" y="256" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="296" y="160" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="296" y="192" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="296" y="224" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <rect x="296" y="256" width="16" height="16" />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M472.009,120c-0.003,0-0.006,0-0.009,0H352V8c0.003-4.416-3.575-7.997-7.991-8c-0.003,0-0.006,0-0.009,0H136
  c-4.416-0.003-7.997,3.575-8,7.991c0,0.003,0,0.006,0,0.009v112H8c-4.416-0.003-7.997,3.575-8,7.991c0,0.003,0,0.006,0,0.009v288
  c-0.003,4.416,3.575,7.997,7.991,8c0.003,0,0.006,0,0.009,0h16.723c-0.464,2.642-0.706,5.318-0.723,8v40
  c-0.003,4.416,3.575,7.997,7.991,8c0.003,0,0.006,0,0.009,0h416c4.416,0.003,7.997-3.575,8-7.991c0-0.003,0-0.006,0-0.009v-40
  c-0.016-2.682-0.258-5.358-0.723-8H472c4.416,0.003,7.997-3.575,8-7.991c0-0.003,0-0.006,0-0.009V128
  C480.003,123.584,476.425,120.003,472.009,120z M344,344c0,8.837-7.163,16-16,16s-16-7.163-16-16s7.163-16,16-16
  C336.832,328.011,343.989,335.168,344,344z M152,328c8.837,0,16,7.163,16,16s-7.163,16-16,16s-16-7.163-16-16
  C136.011,335.168,143.168,328.011,152,328z M104,464H40v-32c0-17.673,14.327-32,32-32s32,14.327,32,32V464z M56,368
  c0-8.837,7.163-16,16-16s16,7.163,16,16s-7.163,16-16,16C63.168,383.989,56.011,376.832,56,368z M105.212,397.425
  c-3.017-2.91-6.4-5.414-10.064-7.449c12.202-12.784,11.731-33.04-1.053-45.243s-33.04-11.731-45.243,1.053
  c-11.803,12.365-11.803,31.824,0,44.189c-7.636,4.238-13.98,10.467-18.358,18.024H16V136h112v187.056
  c-10.986,12.327-10.615,31.039,0.852,42.92C116.852,372.613,108.253,384.053,105.212,397.425z M184,464h-64v-56
  c0-17.673,14.327-32,32-32s32,14.327,32,32V464z M280,464h-80v-56c0-22.091,17.909-40,40-40c22.091,0,40,17.909,40,40V464z
  M216,328c0-13.255,10.745-24,24-24s24,10.745,24,24s-10.745,24-24,24C226.751,351.986,216.014,341.249,216,328z M288.722,380.495
  c-5.357-9.444-13.327-17.139-22.953-22.16c16.897-14.232,19.057-39.467,4.826-56.364c-14.232-16.897-39.467-19.057-56.364-4.826
  c-16.897,14.232-19.057,39.467-4.826,56.364c1.468,1.743,3.082,3.357,4.826,4.826c-9.626,5.021-17.596,12.716-22.953,22.16
  c-4.206-6-9.722-10.965-16.13-14.519c12.265-12.547,12.037-32.662-0.511-44.927c-8.079-7.898-19.744-10.91-30.637-7.913V16h192
  v297.136c-2.607-0.719-5.296-1.101-8-1.136c-17.626-0.047-31.953,14.204-32,31.831c-0.022,8.248,3.151,16.185,8.852,22.145
  C298.444,369.53,292.928,374.495,288.722,380.495z M360,432v32h-64v-56c0-17.673,14.327-32,32-32c17.673,0,32,14.327,32,32V432z
  M440,464h-64v-32c0-17.673,14.327-32,32-32c17.673,0,32,14.327,32,32V464z M392,368c0-8.837,7.163-16,16-16s16,7.163,16,16
  s-7.163,16-16,16C399.168,383.989,392.011,376.832,392,368z M464,408h-14.494c-4.378-7.557-10.722-13.786-18.358-18.024
  c12.202-12.784,11.731-33.04-1.053-45.243c-12.784-12.202-33.04-11.731-45.243,1.053c-11.803,12.365-11.803,31.824,0,44.189
  c-3.664,2.035-7.048,4.539-10.064,7.449c-3.04-13.372-11.64-24.812-23.64-31.449c11.467-11.881,11.839-30.593,0.853-42.92V136h112
  V408z"
          />
        </g>
      </g>
      <g>
        <g>
          <rect x="376" y="184" width="16" height="128" />
        </g>
      </g>
      <g>
        <g>
          <rect x="424" y="184" width="16" height="128" />
        </g>
      </g>
      <g>
        <g>
          <rect x="40" y="184" width="16" height="128" />
        </g>
      </g>
      <g>
        <g>
          <rect x="88" y="184" width="16" height="128" />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M288.009,32c-0.003,0-0.006,0-0.009,0h-96c-4.416-0.003-7.997,3.575-8,7.991c0,0.003,0,0.006,0,0.009v64
  c-0.003,4.416,3.575,7.997,7.991,8c0.003,0,0.006,0,0.009,0h96c4.416,0.003,7.997-3.575,8-7.991c0-0.003,0-0.006,0-0.009V40
  C296.003,35.584,292.425,32.003,288.009,32z M280,96h-80V48h80V96z"
          />
        </g>
      </g>
    </svg>
  );
};

const IconSystemConfiguration: React.FC<IconProps> = () => {
  return (
    <svg
      id="IconSystemConfiguration"
      height="512"
      viewBox="0 0 64 64"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="m16 10c-3.859 0-7 3.141-7 7s3.141 7 7 7 7-3.141 7-7-3.141-7-7-7zm0 12c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z" />
        <path d="m7 39h2v2h-2z" />
        <path d="m15 39h2v2h-2z" />
        <path d="m19 39h2v2h-2z" />
        <path d="m11 39h2v2h-2z" />
        <path d="m23 39h2v2h-2z" />
        <path d="m60 27c1.654 0 3-1.346 3-3v-20c0-1.654-1.346-3-3-3h-24c-1.654 0-3 1.346-3 3v12h-6v-1.709l-1.55-.544c-.133-.39-.289-.769-.466-1.133l.709-1.478-3.83-3.83-1.478.709c-.364-.177-.743-.333-1.133-.466l-.543-1.549h-5.418l-.544 1.55c-.39.133-.769.289-1.133.466l-1.478-.709-3.83 3.83.709 1.478c-.177.364-.333.743-.466 1.133l-1.549.543v5.417l1.549.545c.134.39.29.769.467 1.133l-.709 1.478 3.83 3.83 1.478-.709c.364.177.743.333 1.133.467l.544 1.548h1.708v7.014c-6.924.137-14 1.708-14 4.986v18c0 3.436 7.775 5 15 5s15-1.564 15-5v-18c0-3.278-7.076-4.849-14-4.986v-7.014h1.708l.545-1.549c.39-.134.769-.29 1.133-.467l1.478.709 3.83-3.83-.709-1.478c.177-.364.333-.743.467-1.133l1.548-.544v-1.708h6v6c0 1.654 1.346 3 3 3h11v4h-11c-1.654 0-3 1.346-3 3v20c0 1.654 1.346 3 3 3h24c1.654 0 3-1.346 3-3v-20c0-1.654-1.346-3-3-3h-11v-4zm-44 34c-8.577 0-13-2.103-13-3v-3.333c2.775 1.588 8.018 2.333 13 2.333s10.225-.745 13-2.333v3.333c0 .897-4.423 3-13 3zm0-6c-8.577 0-13-2.103-13-3v-3.333c2.775 1.588 8.018 2.333 13 2.333s10.225-.745 13-2.333v3.333c0 .897-4.423 3-13 3zm0-6c-8.577 0-13-2.103-13-3v-3.333c2.775 1.588 8.018 2.333 13 2.333s10.225-.745 13-2.333v3.333c0 .897-4.423 3-13 3zm13-9c0 .897-4.423 3-13 3s-13-2.103-13-3 4.423-3 13-3 13 2.103 13 3zm-4-21.708-1.172.411-.141.497c-.171.596-.404 1.161-.693 1.68l-.253.453.537 1.118-1.826 1.826-1.118-.537-.453.253c-.519.289-1.084.522-1.68.693l-.497.142-.412 1.172h-2.584l-.411-1.172-.497-.141c-.596-.171-1.161-.404-1.68-.693l-.453-.253-1.118.537-1.826-1.826.537-1.118-.253-.454c-.289-.519-.522-1.084-.693-1.68l-.142-.497-1.172-.411v-2.583l1.174-.413.142-.497c.169-.595.401-1.159.691-1.679l.253-.453-.537-1.118 1.826-1.826 1.118.537.453-.253c.52-.29 1.084-.522 1.679-.691l.497-.142.413-1.174h2.582l.413 1.174.497.142c.595.169 1.159.401 1.679.691l.453.253 1.118-.537 1.826 1.826-.537 1.118.253.453c.29.52.522 1.084.691 1.679l.142.497 1.174.413zm35 36.708h-24c-.552 0-1-.448-1-1v-13h26v13c0 .552-.448 1-1 1zm1-21v5h-26v-5c0-.552.448-1 1-1h24c.552 0 1 .448 1 1zm-25-31h24c.552 0 1 .448 1 1v5h-26v-5c0-.552.448-1 1-1zm-1 21v-13h26v13c0 .552-.448 1-1 1h-24c-.552 0-1-.448-1-1z" />
        <path d="m45 5h2v2h-2z" />
        <path d="m37 5h2v2h-2z" />
        <path d="m41 5h2v2h-2z" />
        <path d="m37 35h2v2h-2z" />
        <path d="m41 35h2v2h-2z" />
        <path d="m45 35h2v2h-2z" />
        <path d="m37 23h8v-10h-8zm2-8h4v6h-4z" />
        <path d="m47 13h2v2h-2z" />
        <path d="m51 13h8v2h-8z" />
        <path d="m47 17h12v2h-12z" />
        <path d="m47 21h12v2h-12z" />
        <path d="m47 53h12v-10h-12zm2-8h8v6h-8z" />
        <path d="m37 43h8v2h-8z" />
        <path d="m37 47h8v2h-8z" />
        <path d="m37 51h8v2h-8z" />
      </g>
    </svg>
  );
};

export {
  IconUsers,
  IconCompany,
  IconLog,
  IconSessions,
  IconConfiguration,
  IconTenant,
  IconSystemConfiguration,
  StyledEditIcon as EditIcon,
};
